/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogFragment, BlogFragment, FullBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog';

/**
 * Get a single Blog by ID (base - scalars only)
 */
export const getBaseBlogById = gql`
  ${BaseBlogFragment}

  query GetBaseBlogById($id: String!, $locale: String!, $preview: Boolean) {
    blog(id: $id, locale: $locale, preview: $preview) {
      ...BaseBlogFragment
    }
  }
`;

/**
 * Get a single Blog by ID (standard - 1 level deep)
 */
export const getBlogById = gql`
  ${BlogFragment}

  query GetBlogById($id: String!, $locale: String!, $preview: Boolean) {
    blog(id: $id, locale: $locale, preview: $preview) {
      ...BlogFragment
    }
  }
`;

/**
 * Get a single Blog by ID (full - 2 levels deep)
 */
export const getFullBlogById = gql`
  ${FullBlogFragment}

  query GetFullBlogById($id: String!, $locale: String!, $preview: Boolean) {
    blog(id: $id, locale: $locale, preview: $preview) {
      ...FullBlogFragment
    }
  }
`;

/**
 * Get all Blog entries with pagination (base - scalars only)
 */
export const getBaseBlogs = gql`
  ${BaseBlogFragment}

  query GetBaseBlogs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogOrder]
    $where: BlogFilter
    $preview: Boolean
  ) {
    blogCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBlogFragment
      }
    }
  }
`;

/**
 * Get all Blog entries with pagination (standard - 1 level deep)
 */
export const getBlogs = gql`
  ${BlogFragment}

  query GetBlogs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogOrder]
    $where: BlogFilter
    $preview: Boolean
  ) {
    blogCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BlogFragment
      }
    }
  }
`;

/**
 * Get all Blog entries with pagination (full - 2 levels deep)
 */
export const getFullBlogs = gql`
  ${FullBlogFragment}

  query GetFullBlogs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogOrder]
    $where: BlogFilter
    $preview: Boolean
  ) {
    blogCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBlogFragment
      }
    }
  }
`;
